import { render, staticRenderFns } from "./aboutLong.vue?vue&type=template&id=2ccc2e16&scoped=true&"
import script from "./aboutLong.vue?vue&type=script&lang=js&"
export * from "./aboutLong.vue?vue&type=script&lang=js&"
import style0 from "./aboutLong.vue?vue&type=style&index=0&id=2ccc2e16&scoped=true&lang=less&"
import style1 from "./aboutLong.vue?vue&type=style&index=1&id=2ccc2e16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccc2e16",
  null
  
)

export default component.exports